var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupChatNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.81,
    height: 20.81,
    viewBox: "0 0 20.81 20.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 20.81,
    height: 20.81,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    "data-name": "Rectangle 1928",
    width: 18.729,
    height: 18.729,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5422",
    "data-name": "Group 5422",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5421",
    "data-name": "Group 5421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5420",
    "data-name": "Group 5420",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5415",
    "data-name": "Group 5415",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5414",
    "data-name": "Group 5414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5413",
    "data-name": "Group 5413",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    width: 20.81,
    height: 20.81,
    fill: "#ffe4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5418",
    "data-name": "Group 5418",
    transform: "translate(1.041 1.041)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5417",
    "data-name": "Group 5417",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5416",
    "data-name": "Group 5416",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    width: 18.729,
    height: 18.729
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M6.657,17.351c-.008.008,0,.008,0,.016l0-.016Z",
    transform: "translate(-0.884 -2.306)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5419",
    "data-name": "Group 5419",
    transform: "translate(1.605 1.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M2.736,4.807a4.743,4.743,0,0,0-.8,2.806,4.9,4.9,0,0,0,1.111,3.017",
    transform: "translate(-1.862 -2.44)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M4.738,2.916A4.313,4.313,0,0,1,7.1,2.248a4.424,4.424,0,0,1,3.045.981,5.383,5.383,0,0,1,1.837,2.887",
    transform: "translate(-2.235 -2.098)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M2.725,4.444s-1.1-2.387-.831-2.367c.218.016,2.505.828,2.492.829",
    transform: "translate(-1.851 -2.077)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M2.776,18.475a4.742,4.742,0,0,1-.8-2.806,4.9,4.9,0,0,1,9.794-.232,4.886,4.886,0,0,1-4.994,5.255A4.311,4.311,0,0,1,4.4,20.025",
    transform: "translate(-1.867 -3.243)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M2.765,19.644s-1.1,2.387-.831,2.367c.218-.016,2.505-.828,2.492-.829",
    transform: "translate(-1.856 -4.412)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M10.724,10.768l.182-1A4.956,4.956,0,0,1,15.49,5.85a5.164,5.164,0,0,1,2.523.593,4.467,4.467,0,0,1,1.723,1.508,5.374,5.374,0,0,1,.864,3.041,4.333,4.333,0,0,1-.724,2.356",
    transform: "translate(-3.03 -2.578)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M18.69,16.338a4.7,4.7,0,0,1-2.816.736,4.853,4.853,0,0,1-2.159-.615",
    transform: "translate(-3.428 -3.972)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M19.453,16.088s2.351,1.166,2.338.892c-.01-.219-.762-2.533-.764-2.521",
    transform: "translate(-4.191 -3.723)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatNewIcon);
export default __webpack_public_path__ + "static/media/Group-chat-new-icon.6d0586e22bc7a62a54b1b246963dabd3.svg";
export { ForwardRef as ReactComponent };